import {ChangeEvent} from 'react';

const StoryDescription = () => (
  <p className="leading-8 text-gray-900">
    با ثبت استوری، به دیده شدن فروشگاه و محصولات خود و درنتیجه، فروش بیشتر کمک
    ‌کنید. برای این کار کافیه فایل استوری خود را بارگذاری کنید و لینک مد نظر خود
    را
    <br />
    (لینک فروشگاه خود در سامانه، لینک سایت اختصاصی و...) برای ورود مشتریان وارد
    کنید. استوری شما پس از ۲۴ ساعت، حذف می‌شود.
  </p>
);

export default StoryDescription;
